import { RootState } from 'store/types';
import { createSelector } from 'reselect';
import { EventListState } from './reducers';

export const eventListSelector = (state: RootState) => state.events.eventList;

export const eventListFetchingSelector = createSelector(
  eventListSelector,
  (eventList: EventListState) => eventList.isFetching
);

export const eventListErrorSelector = createSelector(
  eventListSelector,
  (eventList: EventListState) => eventList.error
);

export const eventListDataSelector = createSelector(
  eventListSelector,
  (eventList: EventListState) => eventList.data || []
);

export const eventListRequestStateSelector = createSelector(
  eventListSelector,
  (eventList: EventListState) => eventList.requestState
);

export const healthAdvisoryItemsSelector = createSelector(eventListDataSelector, eventList => {
  return eventList.filter(event => event.sourceResource === 'healthAdvisory');
});

export const patchEventSelector = (state: RootState) => state.events.patchEvent;

export const patchEventFetchingSelector = createSelector(
  patchEventSelector,
  patchEvent => patchEvent.isFetching
);

export const patchEventErrorSelector = createSelector(
  patchEventSelector,
  patchEvent => patchEvent.error
);

export const patchEventCompletedSelector = createSelector(
  patchEventSelector,
  patchEvent => patchEvent.isComplete
);

export const patchEventMessageSelector = createSelector(
  patchEventSelector,
  patchEvent => patchEvent.message
);

export const acknowledgeEventSelector = (rootState: RootState) => rootState.events.acknowledgeEvent;
export const dismissEventSelector = (rootState: RootState) => rootState.events.dismissEvent;
export const selectedEventSelector = (rootState: RootState) => rootState.events.selectedEvent;
